var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9426 7.55727C25.4633 8.07797 25.4633 8.92219 24.9426 9.44289L8.94265 25.4429C8.42195 25.9636 7.57773 25.9636 7.05703 25.4429C6.53633 24.9222 6.53633 24.078 7.05703 23.5573L23.057 7.55727C23.5777 7.03657 24.4219 7.03657 24.9426 7.55727Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05703 7.55727C7.57773 7.03657 8.42195 7.03657 8.94265 7.55727L24.9426 23.5573C25.4633 24.078 25.4633 24.9222 24.9426 25.4429C24.4219 25.9636 23.5777 25.9636 23.057 25.4429L7.05703 9.44289C6.53633 8.92219 6.53633 8.07797 7.05703 7.55727Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3b14038843e82eb34aa4a893dcab8229.svg";
export { ForwardRef as ReactComponent };